import { useEffect } from 'react';

// eslint-disable-next-line react-hooks/exhaustive-deps
const useMount = (effect: Parameters<typeof useEffect>[0]) => useEffect(effect, []);

export default useMount;
